// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dHzei","form":"styles_form__X6gjJ","logo":"styles_logo__1SkKq","formButton":"styles_formButton__1-nFp","forgot":"styles_forgot__dWQCB"};